/* =====================================================
   ONLINEAND.DIRECT theme JS 2/3: product options (size buttons, swatches), out-of-stock
   panel and back-in-stock fields, quantity stepper, gallery, sticky add to basket.
   ===================================================== */

(function() {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function formatMoney(cents) { return '£' + (cents / 100).toFixed(2); }
  /* Same rule as snippets/olad-display-title.liquid, for JSON-sourced titles */
  function shortTitle(t) { return String(t || '').split(' | ')[0].replace(/^FW ?Style /, ''); }
  var ICON = {
    close: '<svg class="olad-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    check: '<svg class="olad-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m4.5 12.5 4.5 4.5 10.5-11"/></svg>',
    minus: '<svg class="olad-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>',
    plus: '<svg class="olad-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>'
  };

  /* ── PRODUCT OPTIONS ── */
  function initProductOptions() {
    var form = document.getElementById('olad-product-form');
    var variants = window.productVariants;
    if (!form || !variants) return;
    var groups = $all('.olad-opt[data-option-index]', form);
    var idInput = document.getElementById('olad-variant-id');
    var priceEl = document.getElementById('olad-price');
    var noteEl = document.getElementById('olad-price-note');
    var stockEl = document.getElementById('olad-stock');
    var buyRow = document.getElementById('olad-buyrow');
    var addBtn = document.getElementById('olad-add-btn');
    var oos = document.getElementById('olad-oos');
    var stickyPrice = document.getElementById('olad-sticky-price');
    var stickyBtn = document.querySelector('.olad-sticky-cart__btn');
    var mainImg = document.getElementById('olad-main-img');

    function selected() {
      return groups.map(function(g) {
        var c = g.querySelector('.olad-opt__input:checked');
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function markAvailability(opts) {
      groups.forEach(function(g, gi) {
        $all('.olad-opt__input', g).forEach(function(input) {
          var combo = opts.slice(); combo[gi] = input.value;
          var v = findVariant(combo);
          var label = g.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !(v && v.available));
          if (label && !(v && v.available)) label.setAttribute('title', input.value + ' (out of stock)');
        });
      });
    }
    function update(pushUrl) {
      var opts = selected();
      groups.forEach(function(g, gi) { var l = g.querySelector('[data-selected-label]'); if (l) l.textContent = opts[gi] || ''; });
      markAvailability(opts);
      var v = findVariant(opts);
      if (!v) {
        if (buyRow) buyRow.hidden = true;
        if (stockEl) stockEl.hidden = true;
        if (oos) oos.hidden = false;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      if (noteEl) noteEl.textContent = (v.options.length && v.title !== 'Default Title' ? v.options.join(', ') + ', ' : '') + 'inc. VAT';
      var done = oos ? oos.querySelector('[data-notify-done]') : null;
      if (buyRow) buyRow.hidden = !v.available;
      if (stockEl) stockEl.hidden = !v.available;
      if (addBtn) addBtn.disabled = !v.available;
      if (oos) oos.hidden = v.available && !done;
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? 'Add to basket' : 'Out of stock'; }
      if (oos) {
        var tags = oos.querySelector('[data-notify-tags]');
        var body = oos.querySelector('[data-notify-body]');
        var p = window.oladProduct || {};
        if (tags) tags.value = ['back-in-stock', p.handle || '', v.sku || ''].join(',');
        if (body) body.value = 'Back-in-stock request: ' + (p.title || '') + ' - ' + v.title + ' (SKU ' + (v.sku || '') + ')';
      }
      if (v.featured_image && v.featured_image.src && mainImg) {
        mainImg.src = v.featured_image.src;
        mainImg.removeAttribute('srcset');
      }
      if (pushUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    form.addEventListener('change', function(e) {
      if (e.target && e.target.classList && e.target.classList.contains('olad-opt__input')) update(true);
    });
    update(false);

    /* Quantity stepper */
    $all('[data-qty-step]', form).forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = document.getElementById('olad-qty-input');
        if (!input) return;
        var n = (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-qty-step'), 10);
        input.value = Math.min(99, Math.max(1, n));
      });
    });

    /* "UK bed size guide" link opens the guide */
    $all('[data-open-size-guide]').forEach(function(a) {
      a.addEventListener('click', function() { var d = document.getElementById('olad-size-guide'); if (d) d.open = true; });
    });
  }

  /* ── PRODUCT GALLERY ── */
  function initProductGallery() {
    var thumbs = $all('.olad-thumb');
    var mainImg = document.getElementById('olad-main-img');
    if (!thumbs.length || !mainImg) return;
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        thumbs.forEach(function(t) { t.setAttribute('aria-pressed', 'false'); });
        thumb.setAttribute('aria-pressed', 'true');
        var srcset = thumb.getAttribute('data-srcset');
        if (srcset) mainImg.setAttribute('srcset', srcset); else mainImg.removeAttribute('srcset');
        mainImg.src = thumb.getAttribute('data-src');
        mainImg.alt = thumb.getAttribute('data-alt') || '';
      });
    });
  }

  /* ── STICKY ADD TO BASKET (mobile) ── */
  function initStickyCart() {
    var stickyBar = document.getElementById('olad-sticky-cart');
    var form = document.getElementById('olad-product-form');
    if (!stickyBar || !form || !('IntersectionObserver' in window)) return;
    var target = document.getElementById('olad-buyrow') || form;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) { stickyBar.style.display = entry.isIntersecting || entry.boundingClientRect.top > 0 ? 'none' : 'flex'; });
    }, { threshold: 0 });
    observer.observe(target);
    var stickyBtn = stickyBar.querySelector('.olad-sticky-cart__btn');
    if (stickyBtn) stickyBtn.addEventListener('click', function() {
      var btn = document.getElementById('olad-add-btn');
      if (btn && !btn.disabled) btn.click();
    });
  }

  /* ── INIT ── */
  function init() {
    initProductOptions();
    initProductGallery();
    initStickyCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

})();